export const EhrRecordsControllerFactory = ({
  ehrRecordsService,
}: {
  ehrRecordsService: IEhrRecordsService;
}) => {
  const getEhrMedications: IGetEhrMedicationsController = async (obj) =>
    ehrRecordsService.getEhrMedications({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      status: obj.status,
      limit: obj.limit,
      offset: obj.offset,
    });

  const getEhrNutrition: IGetEhrNutritionController = async (obj) =>
    ehrRecordsService.getEhrNutrition({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      status: obj.status,
      limit: obj.limit,
      offset: obj.offset,
    });

  const getEhrAssessments: IGetEhrAssessmentsController = async (obj) =>
    ehrRecordsService.getEhrAssessments({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      assessment_status: obj.assessment_status,
      assessment_type: obj.assessment_type,
      limit: obj.limit,
      offset: obj.offset,
    });

  const getEhrAllergies: IGetEhrAllergiesController = async (obj) =>
    ehrRecordsService.getEhrAllergies({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      status: obj.status,
      category: obj.category,
      clinical_status: obj.clinical_status,
      limit: obj.limit,
      offset: obj.offset,
    });

  const getEhrLabs: IGetEhrLabsController = async (obj) =>
    ehrRecordsService.getEhrLabs({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      report_type: obj.report_type,
      report_status: obj.report_status,
      limit: obj.limit,
      offset: obj.offset,
    });

  const downloadEhrLab: IDownloadEhrLabController = async (obj) =>
    ehrRecordsService.downloadEhrLab({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      lab_id: obj.lab_id,
    });

  const getPccAssessments: IGetPccAssessmentsController = async (obj) =>
    ehrRecordsService.getPccAssessments({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      assessment_status: obj.assessment_status,
      start_date: obj.start_date,
      end_date: obj.end_date,
      template_id: obj.template_id,
      system_template_id: obj.system_template_id,
      template_version: obj.template_version,
      latest_template_version: obj.latest_template_version,
      page: obj.page,
      page_size: obj.page_size,
    });

  const getPccAssessmentDetail: IGetPccAssessmentDetailController = async (
    obj
  ) =>
    ehrRecordsService.getPccAssessmentDetail({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      assessment_id: obj.assessment_id,
    });

  const getCarePlans: IGetCarePlansController = async (obj) =>
    ehrRecordsService.getCarePlans({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      care_plan_status: obj.care_plan_status,
      focus_status: obj.focus_status,
      page: obj.page,
      page_size: obj.page_size,
    });

  const getCarePlanFocuses: IGetCarePlanFocusesController = async (obj) =>
    ehrRecordsService.getCarePlanFocuses({
      clinic_id: obj.clinic_id,
      patient_id: obj.patient_id,
      focus_ids: obj.focus_ids,
    });

  return {
    getEhrMedications,
    getEhrNutrition,
    getEhrAssessments,
    getEhrAllergies,
    getEhrLabs,
    downloadEhrLab,
    getPccAssessments,
    getPccAssessmentDetail,
    getCarePlans,
    getCarePlanFocuses,
  };
};
